const ALLOWED_HREF_PROTOCOLS = new Set(['http:', 'https:', 'tel:', 'mailto:'])

// A "Custom" social link stores a raw, user-editable href with no prefix — unlike the built-in
// types (tel:/mailto:), it passes straight through to `<a href>`. Without validation, a
// `javascript:` URI (including whitespace/tab bypass tricks browsers ignore when parsing a
// scheme) would execute in the customer's browser when the link is clicked. Anything without a
// recognized scheme is treated as a bare domain/path and given an `https://` prefix, matching
// what a user typing e.g. "facebook.com/me" would expect.
export function sanitizeHref(href: string): string {
  const normalized = (href || '').replace(/[\t\n\r]/g, '').trim()
  if (!normalized) return ''

  const schemeMatch = normalized.match(/^([a-z][a-z0-9+.-]*):/i)
  if (schemeMatch) {
    const protocol = `${schemeMatch[1].toLowerCase()}:`
    return ALLOWED_HREF_PROTOCOLS.has(protocol) ? normalized : ''
  }

  return `https://${normalized.replace(/^\/+/, '')}`
}
